import { render, staticRenderFns } from "./CreateTransaction.vue?vue&type=template&id=5ac4a2f7"
import script from "./CreateTransaction.vue?vue&type=script&lang=js"
export * from "./CreateTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports